<kodit-dropdown
  [formCtrlId]="formCtrlId"
  [formCtrl]="vremenskiOpsegCtrl"
  [options]="items"
  ctrlTooltip="Izaberite vremenski opseg"
  ctrlTooltipPosition="top"
></kodit-dropdown>
